<template>
  <div class="mobile-tabs-container">
    <div 
      class="nav-scroller"
      ref="navScroller"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div 
        v-for="(tab, index) in tabs"
        :key="index"
        :class="['nav-item', { 'active': activeIndex === index }]"
        @click="handleNavClick(index)"
      >
        {{ tab.label }}
      </div>
    </div>

    <!-- 垂直滚动内容区域 -->
    <div 
      class="content-scroller"
      ref="contentScroller"
      @scroll.passive="handleContentScroll"
    >
      <div 
        v-for="(tab, index) in tabs"
        :key="index"
        :id="`content-${index}`"
      >
	  <br>index:{{index}}
	  <br>
	  
        dsakdhsa
		hhdhsahds
		dsdss
		dsadsads
		dsa
		dsa
		ds
		adsa
		ds
		<address><s>ds
		
		dsadsad</s></address>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileSideTabs',
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () =>  [
  { label: '首页', content: '首页内容...' },
  { label: '推荐', content: '推荐内容...' },
  { label: '热点', content: '热点新闻...' }
]
    },
    scrollOffset: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      activeIndex: 0,
      touchStartX: 0,
      touchStartY: 0,
      isScrolling: null
    };
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    // 导航点击处理
    handleNavClick(index) {
      this.activeIndex = index;
      this.scrollToContent(index);
      this.scrollNavToCenter(index);
    },

    // 内容滚动到指定位置
    scrollToContent(index) {
      const target = document.getElementById(`content-${index}`);
      if (target) {
        const container = this.$refs.contentScroller;
        const targetTop = target.offsetTop - this.scrollOffset;
        container.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      }
    },

    // 导航栏自动居中
    scrollNavToCenter(index) {
      const container = this.$refs.navScroller;
      const item = container.children[index];
      if (!item) return;

      const containerWidth = container.offsetWidth;
      const itemLeft = item.offsetLeft;
      const itemWidth = item.offsetWidth;
      const scrollTo = itemLeft - (containerWidth - itemWidth) / 2;

      container.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
    },

    // 触摸事件处理
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    },

    handleTouchMove(e) {
      if (!this.isScrolling) {
        const deltaX = Math.abs(e.touches[0].clientX - this.touchStartX);
        const deltaY = Math.abs(e.touches[0].clientY - this.touchStartY);
        this.isScrolling = deltaY > deltaX;
      }
    },

    handleTouchEnd(e) {
      if (!this.isScrolling) {
        const deltaX = e.changedTouches[0].clientX - this.touchStartX;
        if (Math.abs(deltaX) > 50) {
          const direction = deltaX > 0 ? -1 : 1;
          const newIndex = Math.min(
            Math.max(0, this.activeIndex + direction),
            this.tabs.length - 1
          );
          this.handleNavClick(newIndex);
        }
      }
      this.isScrolling = null;
    },

    // 内容滚动同步导航
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = parseInt(entry.target.id.split('-')[1]);
              if (index !== this.activeIndex) {
                this.activeIndex = index;
                this.scrollNavToCenter(index);
              }
            }
          });
        },
        {
          root: this.$refs.contentScroller,
          threshold: 0.5
        }
      );

      this.tabs.forEach((_, index) => {
        const target = document.getElementById(`content-${index}`);
        if (target) this.observer.observe(target);
      });
    },

    // 防抖处理滚动事件
    handleContentScroll: function() {
      if (!this.scrollTimer) {
        this.scrollTimer = setTimeout(() => {
          this.scrollTimer = null;
        }, 100);
      }
    }
  
  }
};
</script>

<style scoped>
.mobile-tabs-container {
  display: flex;
  height: 100vh;
}

.nav-scroller {
  position: sticky;
  top: 0;
  z-index: 10;
}

.nav-scroller::-webkit-scrollbar {
  display: none;
}
.content-scroller {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}


</style>
